import React, { useEffect, useRef,useState } from "react";
import * as d3 from "d3";
import useResizeObserver from "./useResizeObserver";
import { BrowserView , MobileView} from "react-device-detect";

function Tooltip({posX,posY, employerAllData,highlightYear,sectorAllData,stat,hoverColor}){
    
    // console.log(highlightYear)
    // console.log(sectorAllData,employerAllData);
    const [browserStyles,setBrowserStyles] = useState({position:"absolute",left:posX,top:posY,visibility:"hidden"})
    const [mobileStyles,setMobileStyles] = useState({position:"absolute",left:posX,top:posY,visibility:"hidden"})

    const svgTooltipRef1 = useRef();
    // const svgTooltipRef2 = useRef();
    const tooltipWrapperRef1 = useRef();
    // const tooltipWrapperRef2 = useRef();
    var toolDimensions1 = useResizeObserver(tooltipWrapperRef1);
    // var toolDimensions2 = useResizeObserver(tooltipWrapperRef2);

    // if (employerAllData&&sectorAllData){
    if (employerAllData&&highlightYear){
        var employerName = employerAllData[0]['Employer']
        var sectorName = employerAllData[0]['Sector']
        var highlightData = employerAllData.filter((eachRecord)=>{return eachRecord['Calendar Year']==highlightYear})
    }
    var highlightCount = 0;
    var highlightTotal = 0;
    var highlightCapita = 0;
    if (highlightData){
        var highlightCount =  highlightData.length
        var highlightTotal = Math.round(highlightData.map(onePerson=>+onePerson['Salary Paid']).reduce((a,b)=>a+b,0))
        var highlightCapita = Math.round(highlightTotal/highlightCount)
    }

    // var highlightCapita = if (hightlightTotal&&highlightCount) ? Math.round(highlightTotal/highlightCount): 0

    // console.log("tooling")


    useEffect(()=>{
        // if (!toolDimensions1&&!toolDimensions2) {return}
        if (!toolDimensions1){return}
        // if (employerAllData&&sectorAllData){
        if (employerAllData){
            setBrowserStyles({position:"absolute",left:posX,top:posY,visibility:"visible",zIndex:5})
            setMobileStyles({position:"absolute",left:posX,top:posY,visibility:"visible",zIndex:5})

            var width1 = toolDimensions1.width;
            var height1 = toolDimensions1.height;
            var margin_left1 = 15;
            var margin_right1 = 15;
            var margin_top1 = 25;
            var margin_bottom1 = 15;

            // var width2 = toolDimensions2.width;
            // var height2 = toolDimensions2.height;
            // var margin_left2 = 15;
            // var margin_right2 = 15;
            // var margin_top2 = 25;
            // var margin_bottom2 = 15;

            var employerBarData = []
            // var sectorBarData=[]
            for (var year =1996;year<=2020;year++){
                var empYearData = employerAllData.filter((d)=>{return d['Calendar Year']==year})
                var empCount = empYearData.length;
                var empTotal= empYearData.map(onePerson=>+onePerson['Salary Paid']).reduce((a,b)=>a+b,0);
                employerBarData.push({'year':year,'Count':empCount, 'Total':empTotal,'Average':+empTotal/empCount})

                // var sectorYearData = sectorAllData.filter((d)=>{return d['Calendar Year']==year})
                // var sectorCount = sectorYearData.length;
                // var sectorTotal = sectorYearData.map(onePerson=>+onePerson['Salary Paid']).reduce((a,b)=>a+b,0);
                // sectorBarData.push({'year':year,'Count':sectorCount, 'Total':sectorTotal})
                
            }
            // console.log(employerBarData)

            var xScale = d3.scaleLinear().domain([1996,2020]).range([2*margin_left1,width1-2*margin_right1]);
            var maxY1 = d3.max(employerBarData,d=>{return(d[stat])});
            var yScale1 = d3.scaleLinear().domain([0,maxY1]).range([height1-margin_top1,margin_bottom1]).nice();

            var svgTooltip1 = d3.select(svgTooltipRef1.current)
            // var svgTooltip2 = d3.select(svgTooltipRef2.current)

            // console.log(xScale(2000))
            // console.log(xScale(2020))
            // console.log(yScale1(19992))

            svgTooltip1.selectAll(".bargraphs1")
                .data(employerBarData)
                .join("rect")
                .attr("x",(d,i)=>{return xScale(d['year'])})
                .attr("y",margin_bottom1)
                .attr("height",(d,i)=>{return (height1 - margin_top1 - yScale1(d[stat]))})
                .attr("width",6)
                .attr("fill",(d,i)=>{return d['year']==highlightYear?"#be6007b4":"#030341d8"})
                .style("opacity",(d,i)=>{return d['year']==highlightYear?"1":"0.8"})
                .attr("class","bargraphs1")
                .style("transform","translate("+(margin_left1+0*width1)+"px,"+(height1 - 0*margin_bottom1)+"px) scale(1,-1)")
            
            // svgTooltip2.selectAll(".bargraphs2")
            //     .data(sectorAllData)
            //     .join("rect")
            //     .attr("x",(d,i)=>{return xScale(d['year'])})
            //     .attr("y",margin_bottom2)
            //     .attr("height",(d,i)=>{return stat=="Count" ? height2 - margin_top2- yScale2(d['Count']) : height2 - margin_top2- yScale2(d['Total'])})
            //     .attr("width",1)
            //     .attr("fill",(d,i)=>{return d['year']==highlightYear?"red":"black"})
            //     .attr("class","bargraphs2")
            //     .style("transform","translate("+0*width2+"px,"+(height2 - 1*margin_bottom2)+"px) scale(1,-1)")

            var yAxis1 = d3.axisLeft().scale(yScale1).tickSize(width1)
            if (stat == "Count"){
                yAxis1.tickFormat((d)=>{
                    if(d){return d.toLocaleString().replace(/\,/g,'')}
                }).ticks(4)
            }
            else if(stat=="Total"){
                yAxis1.tickFormat((d)=>{
                    if(d){return d.toLocaleString().replace(/\,000\,000$/g,' M').replace(/\,000$/g,' K')}
                }).ticks(4)
            }
            else if (stat == "Average"){
                yAxis1.tickFormat((d)=>{
                    if(d){return d.toLocaleString().replace(/\,000$/g,'K')}
                }).ticks(4)
            }
            svgTooltip1.selectAll(".tooltip-yAxis-1").data([100]).join("g").call(yAxis1)
                .attr("class","tooltip-yAxis-1")
                .style("transform","translate("+(width1+2*margin_left1+margin_right1)+"px,"+(-5+1*margin_bottom1+0*margin_top1)+"px)")

        }
        else{
            // console.log("no employer data")
            setBrowserStyles({position:"absolute",left:posX,top:posY,visibility:"hidden",zIndex:-10})
            setMobileStyles({position:"absolute",left:posX,top:posY,visibility:"hidden",zIndex:-10})
        }
    },[employerAllData,highlightYear,sectorAllData,stat])

    return (
        <React.Fragment>
            <BrowserView viewClassName = "tooltip browserView" style = {browserStyles}>
                <div className = "tooltip-header browser" style = {{background:hoverColor}}>
                    <h4> {employerName} </h4>
                    <h4> {highlightYear} </h4>
                </div>
                <div className = "tooltip-body browser">
                    <div className = "tooltip-wrapper browser" ref = {tooltipWrapperRef1}>
                        <svg className = "tooltip-svg browser" ref = {svgTooltipRef1}></svg>
                    </div>
                </div>
                <div className = "tooltip-footer browser" style = {{background:hoverColor}}>
                    <h4> Employees : {highlightCount.toLocaleString()}</h4>
                    <h4> Total Income : {highlightTotal.toLocaleString()} </h4>
                    <h4> Per-Capita Income : {highlightCapita.toLocaleString()} </h4>
                </div>
                {/* <div className = "tooltip-wrapper browser" ref = {tooltipWrapperRef2}>
                    <p className = "tooltip-title browser"> {sectorName}</p>
                    <svg className = "tooltip-svg browser" ref = {svgTooltipRef2}></svg>
                </div> */}
            </BrowserView>
    
            <MobileView viewClassName = "tooltip mobileView"  style = {mobileStyles}>
                <div className = "tooltip-header mobile" style = {{background:hoverColor}}>
                    <h4>{employerName}</h4>
                    <h4> {highlightYear}</h4>
                </div>
                <div className = "tooltip-body mobile">
                    <div className = "tooltip-wrapper mobile" ref = {tooltipWrapperRef1}>
                        <svg className = "tooltip-svg mobile" ref = {svgTooltipRef1}></svg>
                    </div>
                </div>
                <div className = "tooltip-footer browser" style = {{background:hoverColor}}>
                    <h4> Employees : {highlightCount.toLocaleString()}</h4>
                    <h4> Total Income : {highlightTotal.toLocaleString()} </h4>
                    <h4> Per-Capita Income : {highlightCapita.toLocaleString()} </h4>
                </div>
            </MobileView>
        </React.Fragment>
    )
}

export default Tooltip
